module.exports = __webpack_public_path__ + "static/img/LeableLogo.b67272dd.png";